import { DeliveryData } from "../../../state/types"
import { Customer } from "../../../../sales"
import { DeliveryDataFields } from "../delivery-data-fields/deliveryDataFields"
import { Form } from "../../../../../features/ui"
import { useManagerHooks } from "../../../../manager"
import { useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useActions } from "./actions"
import { AddressQuickFormModal, useAddressBuilders } from "../../../../../features/address"
import { Data2 } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { Operation } from "../../../../operations"

type Props = {
    table: TableName
    operation: Operation
    customer: Customer
}

export const DeliveryDataForm = (props: Props) => {
    const { table, operation } = props
    const defaultCustomer = props.customer

    const { buildAddress } = useAddressBuilders()

    const { currentBranchId } = useManagerHooks()
    const navigate = useNavigate()

    const defaultDeliveryData = useMemo(() => ({
        method: operation?.deliveryData?.method,
        addressId: operation?.deliveryData?.addressId,
        deliveryDate: operation?.deliveryData?.deliveryDate
    }), [operation?.deliveryData])

    const [customer, setCustomer] = useState<Customer>(defaultCustomer)
    const [deliveryData, setDeliveryData] = useState<Partial<DeliveryData>>(defaultDeliveryData)

    const { submitCustomerDeliveryAddress, submitDeliveryData } = useActions()

    const fields = DeliveryDataFields({
        table,
        defaultData: deliveryData,
        customer,
        addressIdValue: deliveryData.addressId,
        branchId: currentBranchId!,
        isMethodOptional: false,
        isAddressOptional: false,
        onChange: setDeliveryData
    })

    const onSubmit = async () => {
        return submitDeliveryData(table, operation.id, deliveryData)
    }

    const onCancel = () => navigate(-1)

    const onCreateCustomerAddress = async (data: Data2) => {
        const address = buildAddress(data)
        const savedCustomer = await submitCustomerDeliveryAddress(customer!, address)
        setCustomer(savedCustomer)
        setDeliveryData({
            ...deliveryData,
            addressId: address.id
        })
    }

    return (
        <>
            <Form
                formId="delivery-data-form"
                fields={fields}
                createLabel="Guardar"
                onSubmit={onSubmit}
                onCancel={onCancel}
            />
            <AddressQuickFormModal onSubmit={onCreateCustomerAddress} />
        </>
    )
}
